import styled, { keyframes } from 'styled-components'
import { ANATOMY_V2_ACCENT_COLOR } from '~/pages/anatomyV2/libs/constants'
import {
  anatomyV2ContentWrapperCss,
  anatomyV2RootCss,
} from '~/pages/anatomyV2/libs/pageLayoutStyles'
import { Button } from '~/shared/components/Button'
import { COLORS } from '~/shared/constants/uiConstants'

const drawCurve = keyframes`
  from { stroke-dashoffset: 1; }
  to { stroke-dashoffset: 0; }
`

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`

export const AnatomyV2LearningProfileStyles = {
  Root: styled.div`
    ${anatomyV2RootCss}
    overflow: hidden;
  `,

  ContentWrapper: styled.div`
    ${anatomyV2ContentWrapperCss}
    min-height: 0;
  `,

  ScrollContent: styled.div`
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    padding: 16px;
  `,

  Title: styled.h1`
    font-family: 'Mulish', sans-serif;
    font-size: 22px;
    font-weight: 700;
    line-height: 1.2;
    text-align: center;
    color: ${COLORS.BLACK};
    margin: 24px 0 50px;
  `,

  ChartWrapper: styled.div`
    position: relative;
    margin-bottom: 24px;
  `,

  ChartSvg: styled.svg`
    width: 100%;
    height: auto;
    display: block;
    overflow: visible;
  `,

  AnimatedCurve: styled.path`
    stroke-dasharray: 1;
    stroke-dashoffset: 1;
    animation: ${drawCurve} 1.2s ease-out forwards;
  `,

  ScoreMarkerGroup: styled.g`
    opacity: 0;
    animation: ${fadeIn} 0.3s ease-out forwards;
  `,

  ScoreCard: styled.div`
    position: absolute;
    top: -20px;
    left: 50%;
    transform: translate(-50%, 0);
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    background: ${COLORS.WHITE};
    border-radius: 10px;
    padding: 6px 24px 12px;
    box-shadow: 0px 4px 10px 0px rgba(62, 11, 143, 0.1);
  `,

  ScoreStar: styled.span`
    position: absolute;
    top: 8px;
    right: 8px;
    display: flex;
  `,

  ScoreRow: styled.div`
    display: flex;
    align-items: baseline;
    justify-content: center;
    gap: 2px;
  `,

  ScoreNumber: styled.span`
    font-family: 'Mulish', sans-serif;
    font-size: 44px;
    font-weight: 900;
    line-height: 1;
    color: #6e68ee;
  `,

  ScoreDenominator: styled.span`
    font-family: 'Mulish', sans-serif;
    font-size: 22px;
    font-weight: 500;
    line-height: 1;
    color: ${COLORS.BLACK};
  `,

  ScoreLabel: styled.p`
    font-family: 'Mulish', sans-serif;
    font-size: 15px;
    font-weight: 500;
    line-height: 1;
    color: ${COLORS.BLACK};
    margin-top: 4px;
    white-space: nowrap;
  `,

  Grid: styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
    margin-bottom: 24px;
  `,

  InfoCard: styled.div`
    position: relative;
    background: ${COLORS.WHITE};
    border-radius: 10px;
    padding: 24px 12px;
  `,

  IconBadge: styled.span`
    position: absolute;
    top: 5px;
    right: 5px;
    width: 24px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  `,

  InfoLabel: styled.p`
    font-family: 'Mulish', sans-serif;
    font-size: 13px;
    font-weight: 700;
    color: ${ANATOMY_V2_ACCENT_COLOR};
    margin-bottom: 4px;
  `,

  InfoValue: styled.p`
    font-family: 'Mulish', sans-serif;
    font-size: 16px;
    font-weight: 700;
    line-height: 1.3;
    color: ${COLORS.BLACK};
  `,

  ButtonWrapper: styled.div`
    width: 100%;
    padding: 16px;
  `,

  StyledButton: styled(Button)`
    width: 100%;
  `,
}
